import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./routes/ProtectedRoute";
import AllLeads from "./views/AllLeads";
import BrokerDetail from "./views/BrokerDetail";
import Brokers from "./views/Brokers";
import CancellationRequests from "./views/CancellationRequests";
import Coupons from "./views/Coupons";
import ExpiringPaymentMethods from "./views/ExpiringPaymentMethods";
import Health from "./views/Health";
import HistoricalCustomers from "./views/HistoricalCustomers";
import Impagos from "./views/Impagos";
import LeadDetail from "./views/LeadDetail";
import Login from "./views/Login";
import OnboardingCustomers from "./views/OnboardingCustomers";
import Promos from "./views/Promos";
import Recobros from "./views/Recobros";
import AutoRecobro from "./views/Recobros/AutoRecobro";
import Cartera from "./views/Recobros/Cartera";
import Condonados from "./views/Recobros/Condonados";
import EpisodeDetail from "./views/Recobros/EpisodeDetail";
import ShadowFeed from "./views/Recobros/ShadowFeed";
import Tareas from "./views/Recobros/Tareas";
import CadenceList, { CadenceEditor } from "./views/Recobros/CadenceEditor";
import RenovacionesItalia from "./views/RenovacionesItalia";
import SubscriptionDetail from "./views/SubscriptionDetail";
import Subscriptions from "./views/Subscriptions";
import Tickets from "./views/Tickets";
import TicketDetail from "./views/Tickets/TicketDetail";
import TicketsBoard from "./views/TicketsBoard";
import Calls from "./views/Calls";
import Collections from "./views/Collections";
import "./App.css";

const Protected = ({ children }: { children: React.ReactNode }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={<Navigate to="/operations/onboarding" replace />}
      />
      <Route
        path="/operations/onboarding"
        element={
          <Protected>
            <OnboardingCustomers />
          </Protected>
        }
      />
      <Route
        path="/operations/leads/search"
        element={
          <Protected>
            <AllLeads />
          </Protected>
        }
      />
      <Route
        path="/operations/historical"
        element={
          <Protected>
            <HistoricalCustomers />
          </Protected>
        }
      />
      <Route
        path="/operations/renewals-it"
        element={
          <Protected>
            <RenovacionesItalia />
          </Protected>
        }
      />
      <Route
        path="/operations/subscriptions"
        element={
          <Protected>
            <Subscriptions />
          </Protected>
        }
      />
      <Route
        path="/operations/collections"
        element={
          <Protected>
            <Collections />
          </Protected>
        }
      />
      <Route
        path="/operations/impagos"
        element={
          <Protected>
            <Impagos />
          </Protected>
        }
      />
      {/*
        Panel Recobros. Las rutas se registran SIEMPRE: la disponibilidad de
        ms-ops sólo se conoce cuando el passthrough del admin-api
        (`/api/admin/ops/*`) responde, y es la propia vista la que hace esa
        llamada. Si el entorno no tiene `MS_OPS_BASE_URL`, el proxy devuelve
        404, la vista muestra "no disponible en este entorno" y el enlace del
        sidebar se oculta (ver `api/msops.ts`).
      */}
      <Route
        path="/operations/recobros"
        element={
          <Protected>
            <Recobros />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/shadow"
        element={
          <Protected>
            <ShadowFeed />
          </Protected>
        }
      />
      {/*
        Las rutas LITERALES (`tareas`, `cadencias`) van ANTES que
        `:episodeId`: registradas después, "tareas" casaría como identificador
        de episodio y la pantalla sería inalcanzable.
      */}
      <Route
        path="/operations/recobros/condonados"
        element={
          <Protected>
            <Condonados />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/cartera"
        element={
          <Protected>
            <Cartera />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/auto-recobro"
        element={
          <Protected>
            <AutoRecobro />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/tareas"
        element={
          <Protected>
            <Tareas />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/cadencias"
        element={
          <Protected>
            <CadenceList />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/cadencias/:cadenceId"
        element={
          <Protected>
            <CadenceEditor />
          </Protected>
        }
      />
      <Route
        path="/operations/recobros/:episodeId"
        element={
          <Protected>
            <EpisodeDetail />
          </Protected>
        }
      />
      <Route
        path="/operations/payment-methods/expiring"
        element={
          <Protected>
            <ExpiringPaymentMethods />
          </Protected>
        }
      />
      <Route
        path="/operations/cancellation-requests"
        element={
          <Protected>
            <CancellationRequests />
          </Protected>
        }
      />
      <Route
        path="/operations/coupons"
        element={
          <Protected>
            <Coupons />
          </Protected>
        }
      />
      <Route
        path="/operations/promos"
        element={
          <Protected>
            <Promos />
          </Protected>
        }
      />
      <Route
        path="/operations/tickets"
        element={
          <Protected>
            <Tickets />
          </Protected>
        }
      />
      <Route
        path="/operations/tickets/board"
        element={
          <Protected>
            <TicketsBoard />
          </Protected>
        }
      />
      <Route
        path="/operations/tickets/:ticketId"
        element={
          <Protected>
            <TicketDetail />
          </Protected>
        }
      />
      <Route
        path="/operations/calls"
        element={
          <Protected>
            <Calls />
          </Protected>
        }
      />
      <Route
        path="/brokers"
        element={
          <Protected>
            <Brokers />
          </Protected>
        }
      />
      <Route
        path="/brokers/:brokerId"
        element={
          <Protected>
            <BrokerDetail />
          </Protected>
        }
      />
      <Route
        path="/leads/:leadUlid"
        element={
          <Protected>
            <LeadDetail />
          </Protected>
        }
      />
      <Route
        path="/subscriptions/:subscriptionId"
        element={
          <Protected>
            <SubscriptionDetail />
          </Protected>
        }
      />
      <Route
        path="/health"
        element={
          <Protected>
            <Health />
          </Protected>
        }
      />
      <Route
        path="*"
        element={<Navigate to="/operations/onboarding" replace />}
      />
    </Routes>
  );
}
